<div class="container">
  <div class="wrapper" fxLayout="column" fxLayoutGap="42px">
    <!--TOP PART-->
    <div class="search-container" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="40px"
      fxLayoutAlign="space-between center">
      <div class="description" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="32px" fxLayoutAlign="start start"
        fxLayoutAlign.lt-sm="center center">
        <img src="../../../../assets/img/icons/hand.png" alt="" />
        <div class="text">Informations relatives aux demandes d’emploi</div>
      </div>
      <label class="input-container" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0" fxLayoutGap.lt-sm="24px"
        fxLayoutAlign="space-between center" for="new-letter">
        <input type="text" id="new-letter" name="new-letter" placeholder="Abonnement aux newsletters" />
        <button type="submit">S'abonner</button>
      </label>
    </div>
    <!--BOTTOM PART-->
    <div fxLayout="column" fxLayoutGap="40px">
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="32px">
        <div fxLayout="column" fxLayout.lt-md="row" fxLayout.lt-sm="column-reverse" fxLayoutGap="25px"
          fxLayoutAlign="start start" fxLayoutAlign.lt-sm="start start">
          <div fxLayout="column" fxLayoutGap="25px" fxLayoutGap.lt-sm="16px" fxLayoutAlign="start start">
            <h3 class="title">A propos</h3>
            <div class="text" style="max-width: 300px">
              Databeez est une plateforme qui connecte les personnes aux
              meilleures opportunités (emplois, stages, ou formations) grâce à nos
              algorithmes d'intelligence artificielle. Déposez gratuitement vos
              annonces et accéder à un outil de pilotage performant.
            </div>
          </div>
          <ul fxLayout="row" fxLayoutGap="23px" style="margin-top: 14px">
            <li class="social-item">
              <a href="#"><img src="../../../../assets/img/icons/icon-linkedin.png" alt="" /></a>
            </li>
            <li class="social-item">
              <a href="#">
                <img src="../../../../assets/img/icons/icon-fb.png" alt="" />
              </a>
            </li>
            <li class="social-item">
              <a href="#"><img src="../../../../assets/img/icons/icon-twitter.png" alt="" /></a>
            </li>
            <li class="social-item">
              <a href="#"><img src="../../../../assets/img/icons/icon-ytb.png" alt="" /></a>
            </li>
            <li class="social-item">
              <a href="#"><img src="../../../../assets/img/icons/icon-insta.png" alt="" /></a>
            </li>
          </ul>
        </div>
        <div fxFlex="" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-between start" fxLayoutGap="24px">
          <div fxLayout="column" fxLayoutGap="25px" fxLayoutGap.lt-sm="16px" fxLayoutAlign="start start">
            <h3 class="title">Talents</h3>
            <ul>
              <li class="link"><a href="#">Déposer mon CV</a></li>
              <li class="link"><a href="#">Saisir une opportunité</a></li>
            </ul>
          </div>
          <div fxLayout="column" fxLayoutGap="25px" fxLayoutGap.lt-sm="16px" fxLayoutAlign="start start">
            <h3 class="title">Entreprises</h3>
            <ul>
              <li class="link"><a href="#">Créer ma Page</a></li>
              <li class="link"><a href="#">Publier une opportunité</a></li>
              <li class="link"><a href="#">Dashboard</a></li>
              <li class="link"><a href="#">Tarifs</a></li>
            </ul>
          </div>
          <div fxLayout="column" fxLayoutGap="25px" fxLayoutGap.lt-sm="16px" fxLayoutAlign="start start">
            <h3 class="title">Ressources</h3>
            <ul>
              <li class="link"><a href="#">Blogs</a></li>
              <li class="link"><a href="#">FAQ</a></li>
              <li class="link"><a href="#">Kit Média</a></li>
              <li class="link"><a href="#">Data talents</a></li>
            </ul>
          </div>
          <div fxLayout="column" fxLayoutGap="25px" fxLayoutGap.lt-sm="16px" fxLayoutAlign="start start">
            <h3 class="title">Contact</h3>
            <ul fxLayout="column" fxLayoutGap="10px">
              <li class="link" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px">
                <mat-icon>phone</mat-icon>
                <span class="text">+221 77 456 18 18</span>
              </li>
              <li class="link">
                <button fxFlex class="text btn-contact">Nous contacter</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutGap="24px"
        class="Politique-container">
        <p fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <span>©2023</span>
          <span class="text">databeez.</span>
          <span>All right reserved</span>
        </p>

        <p fxLayout="row" fxLayoutAlign="start center" class="text">
          French
        </p>
        <p fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.lt-sm="center center" fxLayoutGap="10px">
          <a class="text-on-1-line" href="#">Termes & Conditions</a>
          <span> |</span>
          <a class="text-on-1-line" href="#">Politique de confidentialité</a>
        </p>
      </div>
    </div>
  </div>
</div>